module.exports = {
	"GamesLoaded"
	"GameAdded"
	"GameRemoved"
	"RoundAdded"
	"RoundUpdated"
	"RoundRemoved"
	"GamesImported"
}